import {ChangeDetectionStrategy, Component, Input,} from '@angular/core';
import {BaseComponent} from 'compob2b-libs';
import {ListFilterService} from '../../services/list-filter.service';
import {AsyncPipe, NgIf} from "@angular/common";

@Component({
    selector: 'app-filter-count',
    template: `
    <ng-container *ngIf="filter.getCtnActiveFeatures() | async as cnt">
      <div class="count-filter">
        {{ cnt }}
      </div>
    </ng-container>
  `,
    styles: `
    .count-filter {
      background: var(--button-filled-primary-background-color);
      font-size: 12px;
      line-height: 20px;
      color: var(--button-filled-primary-text-color);
      padding: 0;
      border-radius: 50%;
      z-index: 10;
      position: absolute;
      width: 18px;
      height: 18px;
      top: -5px;
      right: 6px;
      text-align: center;
    }
  `,
    imports: [
        NgIf,
        AsyncPipe
    ],
    standalone:true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterCountComponent extends BaseComponent {
  @Input() filter: ListFilterService;

}
